import { dew as _chainDew } from "../../errors/chain.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.assertCurrentChain = void 0;
  const chain_js_1 = _chainDew();
  function assertCurrentChain({
    chain,
    currentChainId
  }) {
    if (!chain) throw new chain_js_1.ChainNotFoundError();
    if (currentChainId !== chain.id) throw new chain_js_1.ChainMismatchError({
      chain,
      currentChainId
    });
  }
  exports.assertCurrentChain = assertCurrentChain;
  //# sourceMappingURL=assertCurrentChain.js.map
  return exports;
}